import type { RadioButtonIndicator, RadioButtonSize } from "./types";

/**
 * Native tap area: the `hitSlop` on each side that brings each style and
 * size's phone diameter (fill 18, 22; check 20, 24) to 44pt; web grows the same
 * way on touch screens (`touchTargetClassName`, as Checkbox and Switch). Fabric
 * counts hitSlop in the parent's overflow inset, so a content-sized parent
 * doesn't clip it. An `overflow-hidden` ancestor still clips it, and a later
 * sibling that overlaps it takes the touch first. A caller's `hitSlop` wins.
 */
export const radioButtonHitSlop: Record<RadioButtonIndicator, Record<RadioButtonSize, number>> = {
  fill: { sm: 13, md: 11 },
  check: { sm: 12, md: 10 },
};
